// extracted by mini-css-extract-plugin
export default {"stackingContext":"PdfPickerModal_stackingContext__6jvfi"};